import styled from "styled-components";

import { AIBadge } from "@similarweb/ai-kit";
import { SWReactCountryIcons, SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { Spinner } from "pro-features/components/Loaders/src/Spinner";
import { CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const BannerContainer = styled(FlexRow)`
    align-items: center;
    margin-bottom: 24px;
    > div {
        justify-content: space-between;
        align-items: center;
        padding: 24px 32px;
    }
`;

export const ActionButton = styled.div`
    margin-left: 16px;
`;

export const IconContainer = styled(FlexRow)`
    margin: 8px 32px 8px 0;
    align-items: center;
    width: 51px;
    height: 66px;
    ${SWReactIcons} {
        line-height: 10px;
        svg {
            width: 100%;
        }
    }
`;

export const BannerTitle = styled(FlexRow)`
    align-items: center;
    ${setFontVariant("h6", colorsPalettes.carbon[500])};
    margin: 0 0 6px 0;
    div {
        margin-left: 8px;
    }
`;

export const Description = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
    margin-bottom: 12px;
`;

export const BadgeContainer = styled(FlexRow)`
    gap: 8px;
`;

// SEOAnalysisForm styles
export const Container = styled.div`
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 20px;
    height: 620px;
    overflow-y: auto;
`;

export const SectionTitle = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

export const SectionText = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
`;

export const SectionTextMessage = styled(SectionText)`
    ${setFontVariant("listItem3", colorsPalettes.carbon[500])};
`;

export const SectionTextBold = styled(SectionText)`
    font-weight: 700;
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const ListItem = styled(SectionText)`
    gap: 8px;
    margin-bottom: 6px;
`;

export const Divider = styled.div`
    height: 1px;
    background-color: ${colorsPalettes.carbon[50]};
    margin: 24px 0;
`;

export const SelectionSection = styled.div`
    margin-bottom: 8px;
`;
export const TextContainer = styled.div`
    margin-bottom: 16px;
`;

export const SelectionLabel = styled.div`
    ${setFontVariant("listItem4", colorsPalettes.carbon[500])};
    margin-bottom: 8px;
`;

export const ActionSection = styled.div<{ marginTop?: number }>`
    margin-top: ${({ marginTop = 24 }) => `${marginTop}px`};
`;

// SelectionBox styles
export const StyledSelectionBox = styled(FlexRow)`
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 8px;
    padding: 4px;
    align-items: center;
    width: 50%;
`;

export const IconWrapper = styled(FlexRow)`
    width: 24px;
    height: 24px;
    margin: 4px;
    margin-right: 8px;
    align-items: center;
    ${SWReactCountryIcons} {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const IconKeywordsWrapper = styled(CenteredFlexRow)`
    border-radius: 8px;
    border: 1px solid ${colorsPalettes.carbon[100]};
    align-items: center;
    width: 32px;
    height: 32px;
    margin-right: 4px;
    background-color: ${colorsPalettes.carbon[0]};
`;

export const SelectionTextWrapper = styled(FlexRow)`
    justify-content: space-between;
    gap: 7px;
    width: 100%;
    overflow: hidden;
`;

const TextOverflow = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
`;

export const LabelOverflow = styled(TextOverflow)`
    ${setFontVariant("queryBar1", colorsPalettes.carbon[400])};
`;

export const TitleOverflow = styled(TextOverflow)`
    ${setFontVariant("chip1TopRow", colorsPalettes.carbon[500])};
`;

export const AutocompleteWrapper = styled.div`
    position: relative;
    height: 50px;
    width: 100%;
`;

// AIAgentFrame styles
export const FloatingFrameWrapper = styled.div`
    position: fixed;
    width: 460px;
    bottom: calc(50vh - 415px);
    right: 16px;
    height: 830px;
    z-index: 1070;
`;

export const ModalTitle = styled.div`
    margin-bottom: 16px;
    ${setFontVariant("h6", colorsPalettes.carbon[500])};
`;

export const ModalMessage = styled.p`
    margin-bottom: 24px;
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
`;

export const ButtonsContainer = styled(FlexRow)`
    justify-content: end;
    gap: 16px;
`;

export const LoadingSpinner = styled(Spinner)<{ top?: string }>`
    margin: 0 auto;
    position: relative;
    top: ${({ top }) => (top ? top : "40px")};
    width: 16px;
    height: 16px;
`;

export const LoadingContainer = styled(CenteredFlexRow)`
    margin-left: 12px;
`;

export const AIBadgeWrapper = styled(AIBadge)`
    background: ${colorsPalettes.mint[500]};
    span {
        color: ${colorsPalettes.carbon[0]};
    }
`;
